import React, { useState, useEffect } from "react";
import {
  MdStar,
  MdStarBorder,
  MdRateReview,
  MdInfoOutline,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdHistory,
  MdPerson,
} from "react-icons/md";
import { Link } from "react-router-dom";

import { usersAPI, ratingsAPI } from "services/api";
import { useAuth } from "context/AuthContext";

// --- YARDIMCI FONKSİYONLAR ---
// Premium Yıldız Bileşeni
const StarRating = ({ rating }) => {
  const stars = [];
  const numRating = Number(rating || 0);
  for (let i = 1; i <= 5; i++) {
    if (i <= numRating) {
      stars.push(<MdStar key={i} className="text-lg text-amber-500" />);
    } else {
      stars.push(
        <MdStarBorder
          key={i}
          className="text-lg text-gray-300 dark:text-gray-600"
        />
      );
    }
  }
  return <div className="flex items-center gap-0.5">{stars}</div>;
};

// İsim Gizleme (Anonimleştirme) Fonksiyonu Yedek (Gerçi direkt Anonim yazacağız ama bulunsun)
const getAnonymousName = () => "Anonim Müşteri";

// --- SKELETON LOADERS ---
const StaffSkeletonGrid = () => (
  <div className="grid animate-pulse grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
    {[...Array(5)].map((_, i) => (
      <div
        key={i}
        className="h-40 w-full rounded-2xl bg-gray-200 dark:bg-navy-700"
      />
    ))}
  </div>
);

const ReviewsSkeletonList = () => (
  <div className="mt-4 flex animate-pulse flex-col gap-4">
    <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
    {[...Array(4)].map((_, i) => (
      <div
        key={i}
        className="h-24 w-full rounded-2xl bg-gray-100 dark:bg-navy-900/50"
      />
    ))}
  </div>
);

const CustomerComments = () => {
  // --- STATE KONTROLLERİ ---
  const [staffList, setStaffList] = useState([]);
  const [allRatings, setAllRatings] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [filteredRatings, setFilteredRatings] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Responsive Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(window.innerWidth < 768 ? 5 : 10);

  const { logout } = useAuth();
  const handleAuthError = () => logout();

  // Ekran boyutu değiştiğinde PageSize'ı güncelle
  useEffect(() => {
    const handleResize = () => setPageSize(window.innerWidth < 768 ? 5 : 10);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- İLK YÜKLEME ---
  useEffect(() => {
    let mounted = true;
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        setError(null);

        const [staffResponse, ratingsResponse] = await Promise.all([
          usersAPI.getStaff(), // public endpoint
          ratingsAPI.getAll(), // api.php'de customer rolüne de açılmalı!
        ]);

        if (
          !staffResponse?.success ||
          !staffResponse?.staff ||
          !ratingsResponse?.success
        ) {
          throw new Error("Veriler yüklenirken bir hata oluştu.");
        }

        if (mounted) {
          // Sadece aktif olan personelleri filtrele
          const activeStaff = staffResponse.staff.filter(
            (s) => s.status !== "passive"
          );
          setStaffList(activeStaff);
          setAllRatings(ratingsResponse.ratings || []);
        }
      } catch (err) {
        console.error("Initial fetch error:", err);
        if (
          String(err.message).includes("401") ||
          String(err.message).includes("Unauthorized")
        ) {
          handleAuthError();
          return;
        }
        if (mounted)
          setError(
            err.message ||
              "Veriler yüklenirken bir hata oluştu. Lütfen tekrar deneyin."
          );
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchInitialData();
    return () => {
      mounted = false;
    };
  }, []);

  // --- SEÇİLİ PERSONELE GÖRE FİLTRELEME ---
  useEffect(() => {
    if (!selectedStaff) {
      setFilteredRatings([]);
      return;
    }

    const ratingsForStaff = (allRatings || [])
      .filter((r) => r.staff_id === selectedStaff.id)
      .map((r) => ({
        id: r.id,
        // Müşteri adını asla gösterme, anonim yap!
        customerName: getAnonymousName(),
        rawDate: new Date(r.created_at).getTime(),
        date: new Date(r.created_at).toLocaleDateString("tr-TR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
        rating: Number(r.rating || 0),
        comment: r.comment || "Yorum yapılmamış",
      }))
      .sort((a, b) => b.rawDate - a.rawDate);

    setFilteredRatings(ratingsForStaff);
  }, [selectedStaff, allRatings]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedStaff]);

  const handleSelectStaff = (staff) => {
    setSelectedStaff((prev) => (prev?.id === staff.id ? null : staff));
  };

  // --- SAYFALAMA HESAPLARI ---
  const totalItems = filteredRatings.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const pageStartIndex = (currentPage - 1) * pageSize;
  const currentPageItems = filteredRatings.slice(
    pageStartIndex,
    pageStartIndex + pageSize
  );

  const goToPage = (p) => {
    if (p < 1 || p > totalPages) return;
    setCurrentPage(p);
  };

  return (
    <div className="animate-fadeIn mt-5 flex w-full flex-col gap-6 pb-20">
      {/* ÜST BAŞLIK & BİLGİLENDİRME */}
      <div className="flex flex-col items-center justify-between gap-6 rounded-[20px] border border-gray-100 bg-white p-6 shadow-3xl shadow-shadow-500 dark:border-white/10 dark:bg-navy-800 dark:shadow-none md:flex-row">
        <div className="flex w-full items-center gap-4 md:w-auto">
          <div className="flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-brand-500/10 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400">
            <MdRateReview className="text-3xl" />
          </div>
          <div>
            <h4 className="text-xl font-bold text-navy-700 dark:text-white">
              Ekibimizin Yorumları
            </h4>
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
              Ustalarımızın geçmiş hizmetlerine ait değerlendirmeleri inceleyin.
            </p>
          </div>
        </div>

        {/* ANONİM BİLGİLENDİRMESİ */}
        <div className="flex w-full items-center justify-center gap-2 rounded-xl bg-gray-50 px-4 py-2 text-xs font-bold text-gray-500 dark:bg-navy-900 dark:text-gray-400 md:w-auto">
          <MdInfoOutline className="flex-none text-lg" />
          <span>
            Tüm yorumlar müşteri gizliliği adına <b>Anonim</b> olarak
            yayınlanır.
          </span>
        </div>
      </div>

      {/* CALL TO ACTION (CTA) YÖNLENDİRME BANNER'I */}
      <div className="relative flex flex-col items-center justify-between gap-4 overflow-hidden rounded-[20px] bg-gradient-to-r from-amber-500 to-amber-600 p-6 text-white shadow-lg shadow-amber-500/20 md:flex-row">
        <div className="relative z-10">
          <h5 className="mb-1 text-lg font-bold">
            Siz de Değerlendirme Yapmak İster Misiniz?
          </h5>
          <p className="text-sm text-white/90">
            Yorum yapabilmek için tamamlanmış bir randevunuz olması
            gerekmektedir. Geçmiş randevularınızdan ustalarımıza puan
            verebilirsiniz.
          </p>
        </div>
        <Link
          to="/customer/appointments"
          className="relative z-10 flex flex-none items-center gap-2 rounded-xl bg-white px-6 py-3 font-bold text-amber-600 shadow-md transition-all hover:scale-105"
        >
          <MdHistory className="text-xl" /> Randevularıma Git
        </Link>
        {/* Arka plan efekti */}
        <MdStar className="absolute -bottom-10 -right-10 text-[150px] text-white opacity-10" />
      </div>

      {error && (
        <div className="flex items-center gap-3 rounded-xl border border-red-100 bg-red-50 p-4 text-red-600 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-400">
          <MdInfoOutline className="flex-none text-xl" />
          <span className="text-sm font-bold">{error}</span>
        </div>
      )}

      {/* 1. ADIM: PERSONEL SEÇİMİ */}
      <div className="flex flex-col rounded-[20px] border border-gray-100 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-navy-800">
        <h5 className="mb-4 text-base font-bold text-navy-700 dark:text-white">
          Uzman Seçin
        </h5>

        {loading ? (
          <StaffSkeletonGrid />
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
            {staffList.map((staff) => {
              const fullName = `${staff.name} ${staff.surname}`.trim();
              const isSelected = selectedStaff?.id === staff.id;
              const hasRating = staff.total_ratings > 0;
              const avgRating = Number(staff.average_rating || 0).toFixed(1);

              return (
                <div
                  key={staff.id}
                  onClick={() => handleSelectStaff(staff)}
                  className={`relative flex cursor-pointer flex-col items-center justify-center rounded-[16px] border-2 p-5 transition-all duration-200 ${
                    isSelected
                      ? "border-brand-500 bg-brand-50 shadow-md dark:border-brand-400 dark:bg-brand-400/10"
                      : "border-transparent bg-gray-50/50 hover:border-gray-200 dark:bg-navy-900/50 dark:hover:border-white/10"
                  }`}
                >
                  {isSelected && (
                    <div className="absolute right-2 top-2 h-3 w-3 rounded-full bg-brand-500 shadow-sm" />
                  )}

                  <div
                    className={`mb-3 flex h-14 w-14 items-center justify-center rounded-full font-bold text-white shadow-md ${
                      isSelected
                        ? "bg-brand-500"
                        : "bg-navy-300 dark:bg-navy-600"
                    }`}
                  >
                    {staff.profile_picture ? (
                      <img
                        src={staff.profile_picture}
                        alt="profil"
                        className="h-full w-full rounded-full object-cover"
                      />
                    ) : (
                      <MdPerson className="text-2xl" />
                    )}
                  </div>

                  <h6
                    className={`mb-2 text-center text-sm font-bold leading-tight ${
                      isSelected
                        ? "text-brand-600 dark:text-brand-400"
                        : "text-navy-700 dark:text-white"
                    }`}
                  >
                    {fullName}
                  </h6>

                  <div className="flex flex-col items-center">
                    {hasRating ? (
                      <>
                        <div className="flex items-center gap-1 text-lg font-black leading-none text-amber-500">
                          {avgRating} <MdStar className="text-xl" />
                        </div>
                        <span className="mt-1 text-[10px] font-bold uppercase text-gray-400">
                          ({staff.total_ratings} DEĞERLENDİRME)
                        </span>
                      </>
                    ) : (
                      <span className="inline-flex items-center rounded-md bg-gray-200 px-2 py-1 text-[10px] font-bold uppercase text-gray-500 dark:bg-navy-700 dark:text-gray-400">
                        Yeni Uzman
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* 2. ADIM: DEĞERLENDİRME LİSTESİ */}
      {selectedStaff && (
        <div className="animate-slideUp flex flex-col rounded-[20px] border border-gray-100 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-navy-800">
          <div className="mb-6 flex flex-col justify-between gap-4 border-b border-gray-100 pb-4 dark:border-white/10 sm:flex-row sm:items-center">
            <div>
              <h5 className="text-base font-bold text-navy-700 dark:text-white">
                {selectedStaff.name} {selectedStaff.surname}{" "}
                <span className="font-medium text-gray-500">
                  Hakkındaki Yorumlar
                </span>
              </h5>
            </div>
            {totalItems > 0 && (
              <div className="rounded-lg bg-gray-50 px-3 py-1 text-sm font-bold text-gray-500 dark:bg-navy-900 dark:text-gray-400">
                {pageStartIndex + 1}-
                {Math.min(pageStartIndex + pageSize, totalItems)} / {totalItems}{" "}
                Yorum
              </div>
            )}
          </div>

          {loading ? (
            <ReviewsSkeletonList />
          ) : totalItems === 0 ? (
            <div className="flex flex-col items-center justify-center py-10 opacity-60">
              <MdRateReview className="mb-3 text-6xl text-gray-300 dark:text-gray-600" />
              <h6 className="text-lg font-bold text-navy-700 dark:text-white">
                Henüz Yorum Yok
              </h6>
              <p className="mt-1 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
                Bu uzmanımız için ilk değerlendirmeyi geçmiş randevularınızdan
                siz yapabilirsiniz.
              </p>
            </div>
          ) : (
            <>
              {/* MASAÜSTÜ GÖRÜNÜMÜ */}
              <div className="hidden overflow-x-auto md:block">
                <table className="w-full text-left">
                  <thead>
                    <tr className="border-b border-gray-100 text-[11px] font-bold uppercase tracking-widest text-gray-400 dark:border-white/10">
                      <th className="py-3 pl-4">Müşteri</th>
                      <th className="py-3">Tarih</th>
                      <th className="py-3">Puan</th>
                      <th className="w-1/2 py-3 pr-4">Yorum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPageItems.map((review) => (
                      <tr
                        key={review.id}
                        className="border-b border-gray-50 transition-colors hover:bg-gray-50/50 dark:border-white/5 dark:hover:bg-white/5"
                      >
                        <td className="py-4 pl-4">
                          <div className="flex items-center gap-3">
                            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-xs font-bold text-gray-500 dark:bg-navy-900 dark:text-gray-400">
                              AM
                            </div>
                            <span className="text-sm font-bold italic text-navy-700 dark:text-white">
                              {review.customerName}
                            </span>
                          </div>
                        </td>
                        <td className="py-4 text-sm font-medium text-gray-600 dark:text-gray-400">
                          {review.date}
                        </td>
                        <td className="py-4">
                          <StarRating rating={review.rating} />
                        </td>
                        <td className="py-4 pr-4">
                          <div className="rounded-xl border border-gray-100 bg-gray-50 p-3 text-sm font-medium text-gray-600 dark:border-white/5 dark:bg-navy-900/50 dark:text-gray-300">
                            "{review.comment}"
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* MOBİL GÖRÜNÜMÜ */}
              <div className="grid grid-cols-1 gap-4 md:hidden">
                {currentPageItems.map((review) => (
                  <div
                    key={review.id}
                    className="flex flex-col rounded-[16px] border border-gray-100 bg-gray-50 p-4 dark:border-white/5 dark:bg-navy-900/50"
                  >
                    <div className="mb-3 flex items-start justify-between">
                      <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-100 bg-white text-xs font-bold text-gray-500 shadow-sm dark:border-white/5 dark:bg-navy-800 dark:text-gray-300">
                          AM
                        </div>
                        <div>
                          <h6 className="text-sm font-bold italic leading-tight text-navy-700 dark:text-white">
                            {review.customerName}
                          </h6>
                          <span className="text-xs font-medium text-gray-400">
                            {review.date}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <StarRating rating={review.rating} />
                    </div>
                    <div className="rounded-xl border border-gray-100 bg-white p-3 text-sm font-medium text-gray-600 dark:border-white/5 dark:bg-navy-800 dark:text-gray-300">
                      "{review.comment}"
                    </div>
                  </div>
                ))}
              </div>

              {/* SAYFALAMA */}
              {totalPages > 1 && (
                <div className="mt-6 flex items-center justify-center gap-2 border-t border-gray-100 pt-4 dark:border-white/10">
                  <button
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 transition-all hover:bg-gray-50 disabled:opacity-40 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700"
                  >
                    <MdKeyboardArrowLeft className="text-xl" />
                  </button>

                  <div className="flex items-center gap-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                      .filter(
                        (p) =>
                          p === 1 ||
                          p === totalPages ||
                          Math.abs(p - currentPage) <= 1
                      )
                      .reduce((acc, p, idx, arr) => {
                        if (idx === 0) return [p];
                        if (p - arr[idx - 1] > 1) acc.push(-1);
                        acc.push(p);
                        return acc;
                      }, [])
                      .map((p, idx) =>
                        p === -1 ? (
                          <span
                            key={`sep-${idx}`}
                            className="px-2 text-gray-400"
                          >
                            ...
                          </span>
                        ) : (
                          <button
                            key={p}
                            onClick={() => goToPage(p)}
                            className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold transition-all ${
                              p === currentPage
                                ? "bg-brand-500 text-white shadow-md"
                                : "bg-transparent text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-navy-700"
                            }`}
                          >
                            {p}
                          </button>
                        )
                      )}
                  </div>

                  <button
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 transition-all hover:bg-gray-50 disabled:opacity-40 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700"
                  >
                    <MdKeyboardArrowRight className="text-xl" />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}

      <style jsx="true">{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CustomerComments;
